<form *ngIf="activeGarnishments != undefined">
  <div style="display:block;padding-top:10px;">
    <app-data-table [columns]="tableColumns" [value]="activeGarnishments"
                    [disableSearch]="true" [rightCaptionTemplate]="rightTemplate">
      <ng-template #rightTemplate>
        <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Garnishment" pTooltip="Add New Garnishment" tooltipPosition="top"
                (click)="onClickAddRow()" [disabled]="!displayNewGarnishment">
        </button>

        <button *ngIf="!displayNewGarnishment" pButton class="icon-action" icon="fa fa-info-circle"
                pTooltip="You can have a maximum of Six Ach Disbursements"
                tooltipPosition="top"></button>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
      <button pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Update" tooltipPosition="top" (click)="onClickEditRow(row)">
      </button>
      <button pButton type="button" class="icon-negative" icon="fa fa-trash" pTooltip="Delete" tooltipPosition="top" (click)="onClickDeleteRow(row)">
      </button>
    </ng-template>
  </app-data-table>
  </div>
  <p-confirmDialog></p-confirmDialog>

  <!-- dialog for new Garnishment or editing an existing Garnishment -->
  <p-dialog *ngIf="garnishmentToEdit" [(visible)]="displayDialog" header="Garnishment" [dismissableMask]="true" [responsive]="true" [modal]="true"
            [resizable]="false" [style]="PrimeNgConfig.DialogStyle40"
            [contentStyle]="{'overflow-y':'auto'}">
    <form #dialogForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="courtOrderNumber">Court Order Number*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="courtOrderNumber"
                 name="courtOrderNumber" type="text" [maxlength]="Validation.GarnishmentTextMaxLength"
                 [(ngModel)]="garnishmentToEdit.courtOrderNumber"
                 required/>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Court Order Judge*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="courtOrderJudge"
                 name="courtOrderJudge" type="text" [maxlength]="Validation.GarnishmentTextMaxLength"
                 [(ngModel)]="garnishmentToEdit.courtOrderJudge"
                 required/>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Payment Amount*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="paymentAmount"
                 name="paymentAmount" type="number" [(ngModel)]="garnishmentToEdit.paymentAmount"
                 required/>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Payment Frequency*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="paymentFrequency"
                      [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="paymentTypeDropDown"
                      [(ngModel)]="garnishmentToEdit.paymentFrequency"
                      required></p-dropdown>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Disbursement Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="paymentFrequency"
                      [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="disbursementTypeOptions"
                      [(ngModel)]="garnishmentToEdit.disbursementType"
                      required
                      (onChange)="switchDisbursementType()"></p-dropdown>
          <button pButton class="action-secondary" icon="fa fa-info-circle" label="ACH FAQs"
                  (click)="onClickAchFaq()"></button>
        </div>

        <!-- Recipient Address -->
        <div *ngIf="garnishmentToEdit.disbursementType == DisbursementType.Check" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Address*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <div><input pInputText name="addrln1" type="text" [maxlength]="Validation.AddrMaxLength" [(ngModel)]="garnishmentToEdit.addrLn1" required
                        placeholder="Address"></div>
            <div style="margin-top:10px;"><input pInputText name="addrln2" type="text" class="text-wrapper-address"
                                                 [maxlength]="Validation.AddrMaxLength" [(ngModel)]="garnishmentToEdit.addrLn2" placeholder="Address"></div>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>City*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="city" name="city" type="text" [maxlength]="Validation.CityMaxLength" [(ngModel)]="garnishmentToEdit.city" required/>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>
              {{garnishmentToEdit.country == countryType.USA ? 'State' : 'State/Province/Region'}}*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown *ngIf="garnishmentToEdit.country == countryType.USA"
                        name="State" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="stateMenu"
                        [(ngModel)]="garnishmentToEdit.stateCode"
                        required
                        filter="true"></p-dropdown>

            <input *ngIf="garnishmentToEdit.country != countryType.USA" pInputText name="State" type="text" [maxlength]="Validation.StateCodeMaxLength" [(ngModel)]="garnishmentToEdit.stateCode"
                   required
                   placeholder="">
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label for="paymentAmount">Zip/Postal Code*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input *ngIf="garnishmentToEdit.country == countryType.USA" pInputText name="zipcode" type="text"
                   [minlength]="Validation.UsZipMinLength"
                   [maxlength]="Validation.UsZipMaxLength" [(ngModel)]="garnishmentToEdit.postalCode" required [pattern]="usZipCodePattern" placeholder="Enter Zip Code">
            <input *ngIf="garnishmentToEdit.country != countryType.USA" pInputText name="zipcode" type="text" [minlength]="Validation.NonUsZipMinLength"
                   [maxlength]="Validation.NonUsZipMaxLength" [(ngModel)]="garnishmentToEdit.postalCode" required [pattern]="alphaNumDashRegex" placeholder="Enter Zip Code">
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label for="paymentAmount">Country*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown id="curAddrCountry"
                        name="country"
                        [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '220px'}" [options]="countryDropDown" [(ngModel)]="garnishmentToEdit.country"
                        required
                        filter="true"></p-dropdown>
          </div>

        </div>
        <!-- End of Recipient Address -->

        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="payee">Name of Recipient*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="payee" name="payee" type="text" [maxlength]="Validation.GarnishmentTextMaxLength" [(ngModel)]="garnishmentToEdit.recipientName"
                 required/>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Payment Start On*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-calendar name="paymentStartOn" dataType="string" [dateFormat]="Format.PcalendarDate" icon="fa fa-calendar" showIcon="true"
                      [(ngModel)]="garnishmentToEdit.paymentStartOn" required [monthNavigator]="true" [yearNavigator]="true" [yearRange]="YearRange" readonlyInput="true"></p-calendar>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Payment End On*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8 mobile-scroll">
          <p-calendar name="paymentEndOn" dataType="string" [dateFormat]="Format.PcalendarDate" icon="fa fa-calendar" showIcon="true"
                      [(ngModel)]="garnishmentToEdit.paymentEndOn" required [monthNavigator]="true" [yearNavigator]="true" [yearRange]="YearRange" readonlyInput="true"></p-calendar>
        </div>
        <div *ngIf="garnishmentToEdit.disbursementType == DisbursementType.ACH">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label for="payeeBankAccount">Bank Name*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="bankName" name="bankName" type="text" [(ngModel)]="garnishmentToEdit.payeeACH.bankName" required
                   [maxLength]="Validation.BankNameMaxLength"/>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Nickname*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="nickName" name="bankName" type="text" [(ngModel)]="garnishmentToEdit.payeeACH.nickName" required
                   [maxLength]="Validation.BankNickNameMaxLength"/>
          </div>


          <div class="p-col-12 p-md-4 p-lg-4">
            <label for="payeeBankAccount">Payee Bank Account #*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="payeeBankAccount" name="payeeBankAccount" type="text" [(ngModel)]="garnishmentToEdit.payeeACH.accountNumber" required
                   [maxLength]="Validation.BankAccountNumberMaxLength" [minLength]="Validation.BankAccountNumberMinLength" pattern="^[0-9]{1,17}$"/>
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label for="payeeBankRouting">Payee Bank Routing #*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input pInputText id="payeeBankRouting" name="payeeBankRouting" type="text" [(ngModel)]="garnishmentToEdit.payeeACH.routingNumber" required
                   [maxLength]="Validation.BankRoutingNumberMaxLength" pattern="^[0-9]{1,19}$"/>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Account Type*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown id="accountType" name="accountType" [placeholder]="Validation.DropdownPlaceholder" [options]="achAccountTypesDropdown"
                        [(ngModel)]="garnishmentToEdit.payeeACH.accountType" required></p-dropdown>
          </div>
        </div>
      </div>
    </form>

    <p-footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <!-- disable it until all required field inclduing chargeCodeId are selected -->
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="displayDialog=false"></button>
        <button pButton type="button" class="button-action" icon="fa fa-check"
                label="Add"
                (click)="onClickSaveRow(garnishmentToEdit)" [disabled]="!dialogForm.form.valid"></button>
      </div>
    </p-footer>
  </p-dialog>

  <!--<p-footer>
    <button pButton type="button" class="button-action" label="Save" (click)="onClickSaveGarnishment()"></button>
  </p-footer>-->
</form>
